import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Library from "./pages/Library";
import Trainings from "./pages/Trainings";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Consulting from "./pages/Consulting";

// Training Pages
import WorkHeight from "./pages/training/WorkHeight";
import FireSafety from "./pages/training/FireSafety";
import Hazmat from "./pages/training/Hazmat";
import WorkplaceSafety from "./pages/training/WorkplaceSafety";
import ConfinedSpaces from "./pages/training/ConfinedSpaces";
import PPE from "./pages/training/PPE";
import SafetyOfficersCourse from "./pages/training/SafetyOfficersCourse";
import DigitalSafety from "./pages/training/DigitalSafety";

// Safety Officer Services Pages
import SafetyOfficer from "./pages/services/SafetyOfficer";
import ExternalConsulting from "./pages/services/ExternalConsulting";
import ChooseSafetyOfficer from "./pages/services/ChooseSafetyOfficer";
import SafetyOfficerImportance from "./pages/services/SafetyOfficerImportance";
import SafetyOfficerRoles from "./pages/services/SafetyOfficerRoles";
import IndustrySafetyOfficer from "./pages/services/IndustrySafetyOfficer";
import ConstructionSafetyOfficer from "./pages/services/ConstructionSafetyOfficer";
import SafetyOfficerScope from "./pages/services/SafetyOfficerScope";
import EducationSafetyAudits from "./pages/services/EducationSafetyAudits";
import FieldFile from "./pages/services/FieldFile";
import IncidentInvestigation from "./pages/services/IncidentInvestigation";

import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/library" element={<Library />} />
              <Route path="/trainings" element={<Trainings />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/consulting" element={<Consulting />} />
              
              {/* Safety Officer Services */}
              <Route path="/services/safety-officer" element={<SafetyOfficer />} />
              <Route path="/services/external-consulting" element={<ExternalConsulting />} />
              <Route path="/services/choose-safety-officer" element={<ChooseSafetyOfficer />} />
              <Route path="/services/safety-officer-importance" element={<SafetyOfficerImportance />} />
              <Route path="/services/safety-officer-roles" element={<SafetyOfficerRoles />} />
              <Route path="/services/industry-safety-officer" element={<IndustrySafetyOfficer />} />
              <Route path="/services/construction-safety-officer" element={<ConstructionSafetyOfficer />} />
              <Route path="/services/safety-officer-scope" element={<SafetyOfficerScope />} />
              <Route path="/services/education-safety-audits" element={<EducationSafetyAudits />} />
              <Route path="/services/field-file" element={<FieldFile />} />
              <Route path="/services/incident-investigation" element={<IncidentInvestigation />} />
              
              {/* Training Pages */}
              <Route path="/training/work-height" element={<WorkHeight />} />
              <Route path="/training/fire-safety" element={<FireSafety />} />
              <Route path="/training/hazmat" element={<Hazmat />} />
              <Route path="/training/workplace-safety" element={<WorkplaceSafety />} />
              <Route path="/training/confined-spaces" element={<ConfinedSpaces />} />
              <Route path="/training/ppe" element={<PPE />} />
              <Route path="/training/safety-officers-course" element={<SafetyOfficersCourse />} />
              <Route path="/training/digital-safety" element={<DigitalSafety />} />
              
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
